import { useState } from "react";

/**
 * Show table overlay on initial load or when `request` changes; skip it for background polls of the same request.
 */
const useTableFetchLoading = (isFetching: boolean, isLoading: boolean, request: unknown): boolean => {
    const requestKey = JSON.stringify(request ?? null);
    const [settledRequestKey, setSettledRequestKey] = useState<string | undefined>(undefined);

    if (!isFetching && settledRequestKey !== requestKey) {
        setSettledRequestKey(requestKey);
    }

    return isLoading || (isFetching && settledRequestKey !== requestKey);
};

export default useTableFetchLoading;
